import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalM,
    // Pelo topo, nunca esticado: o grid esticaria o campo sem dica até a
    // altura do vizinho com dica, e o Field do Fluent dividiria a sobra entre
    // rótulo e controle, desalinhando os inputs da mesma linha.
    alignItems: 'start',
    '@media (max-width: 639px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
  },
  three: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    '@media (max-width: 767px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
  },
  four: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    '@media (max-width: 1023px)': {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    '@media (max-width: 639px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
  },
  wide: { gridColumn: '1 / -1' },
});

/**
 * Grade dos formulários e filtros: colunas iguais, campos alinhados pelo
 * topo (rótulos e controles da mesma linha na mesma altura) e uma coluna só
 * em telas estreitas.
 */
export function FormGrid({
  columns = 2,
  className,
  children,
}: {
  columns?: 2 | 3 | 4;
  className?: string;
  children: ReactNode;
}) {
  const styles = useStyles();
  return (
    <div
      className={mergeClasses(
        styles.grid,
        columns === 3 && styles.three,
        columns === 4 && styles.four,
        className,
      )}
    >
      {children}
    </div>
  );
}

/** Célula que ocupa a linha inteira da `FormGrid`. */
export function FormGridWide({ children }: { children: ReactNode }) {
  const styles = useStyles();
  return <div className={styles.wide}>{children}</div>;
}
